import Vue from 'vue'
import VuePNotify from './vue-pnotify'
Vue.use(VuePNotify)
